function Home() {
    return (
      <>
        <video
          autoPlay
          loop
          muted
          playsInline
          preload="auto"
          id="bg-video"
          className="home-video"
        >
          <source src="/hua.mp4" type="video/mp4" />
        </video>
        <img 
          id="name-overlay"
          src="/namechrome.png" 
          alt="Name Chrome"
          className="home-name-overlay"
        />
      </>
    );
  }
  export default Home;
  